<template>
  <div class="news-table-component-container">
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(imagePath)="data">
        <img
          :src="data.value"
          :alt="data.item.image"
        />
      </template>
      
      <template #cell(categoryId)="data">
        <b-badge>
          {{ newsCategoryDict[data.value].name_CH }}
        </b-badge>
      </template>

      <template v-slot:cell(news_CH)="data">
        <div>
          <p :style="{display: 'inline-block', 'margin-right': '8px'}">{{ data.value }}</p>
          <b-button
            size="sm"
            variant="secondary"
            v-b-modal.modal-1
            @click="showNewsDesc(data.item.id)"
          >顯示內文</b-button>
        </div>
      </template>

      <template v-slot:cell(date)="data">
        <p>{{ data.value | toDate }}</p>
      </template>

      <template v-slot:cell(id)="data">
        <b-icon-pencil @click="editData(data.value)" />
        <b-icon-trash @click="deleteData(data.value,data.item.news_CH)" />
      </template>
    </b-table>
    <b-modal
      id="modal-1"
      v-if="newsFilterById"
      title="消息內容"
    >
      <b>中文內容：</b><br>
      <span
        class="my-4"
        v-html="newsFilterById.desc_CH.replace(/\n/g,'<br/>')"
      />
      <hr>
      <b>英文內容：</b><br>
      <span
        class="my-4"
        v-html="newsFilterById.desc_EN.replace(/\n/g,'<br/>')"
      />
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    props: {
      items: Array,
    },
    data() {
      return {
        fields: [
          { key: "imagePath", label: "參展圖片" },
          { key: "categoryId", label: "分類" },
          { key: "news_CH", label: "參展資訊" },
          { key: "date", label: "發布時間" },
          { key: "id", label: "修改/刪除" },
        ],
        focusNewsId: "",
      };
    },
    methods: {
      ...mapActions("backend", ["addMission"]),

      editData: function (id) {
        this.$router.push({
          path: "/admin/edit-news",
          query: { id: id },
        });
      },
      deleteData: function (id, name) {
        this.focusNewsId = id;
        const ensure = confirm("確定要刪除這個品項嗎？");
        if (ensure && this.newsFilterById) {
          let mission = {
            type: "del",
            date: new Date().getTime(),
            ownerId: this.user.id,
            supervisor: "",
            state: "pending",
            comment: "",
            product: "",
            itemID: id,
            news: name,
            Statement: { ...this.newsFilterById },
            system: "News",
          };
          console.log(mission);
          this.addMission(mission);
        }
      },
      showNewsDesc: function (id) {
        this.focusNewsId = id;
      }
    },
    computed: {
      ...mapState('login', ["user"]),
      ...mapState('backend', ['newsCategories']),
      ...mapGetters('backend', ['newsCategoryDict']),
      
      categoryDict: function() {
        if (this.newsCategories.length) {
          return this.newsCategories.reduce((acc, cate) => {
            console.log(cate)
            return {
            ...acc,
            [cate.id]: { ...cate }
          }
          }, {})
        }
        return {}
      },
      newsFilterById: function () {
        if (this.focusNewsId && this.items.length) {
          return this.items.filter((news) => news.id === this.focusNewsId)[0];
        }
        return;
      },
    },
    filters: {
      toDate: (timestamp) => {
        const date = new Date(timestamp);
        let Y = date.getFullYear();
        let M = date.getMonth();
        let D = date.getDate();
        let H = date.getHours();
        let min = (Array(2).join("0") + date.getMinutes()).slice(-2);
        return `${Y}/${M + 1}/${D} ${H}:${min}`;
      },
    },
  };
</script>
